import { useRouter } from 'next/router'
import { BsHeart } from 'react-icons/bs'
import { useFavorite } from 'src/contexto/hooks/useFavorite'
import { autenticado } from 'src/services/auth'
import { BotaoSVG } from './styles'

export type IconColorProps = {
  textColor: string
  backgroundColor: string
}

const Favorito = ({ textColor, backgroundColor }: IconColorProps) => {
  const router = useRouter()
  const { favorites } = useFavorite()

  const onClick = () => {
    if (!autenticado()) {
      return router.push('/login')
    }

    return router.push('/favoritos')
  }

  return (
    <BotaoSVG
      className="area-favorite"
      onClick={() => onClick()}
      backgroundColor={backgroundColor}
      aria-label="Favoritos"
    >
      <div className="round-div">
        {favorites.length > 9 ? '9+' : favorites.length}
      </div>
      <BsHeart color={textColor} />
    </BotaoSVG>
  )
}

export default Favorito
